import Vue from 'vue';
import Vuex from 'vuex';
import { storage } from '../utils/utils';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {

  },
  state: {
    isCollapse: storage.get('isCollapse') || false,
    userInfo: storage.get('userInfo') || null,
    token: storage.get('token') || '',
    loginInfo: storage.get('loginInfo') || '',
    navs: storage.get('navs') || '',
    operate:storage.get('operate') || '',
  },
  getters: {

  },
  mutations: {
    ...mutations,
  },
  actions: {
    ...actions
  }
})